// extracted by mini-css-extract-plugin
module.exports = {"light":"logo-grid_light__2pxOY","dark":"logo-grid_dark__KIguK","logoImg":"logo-grid_logoImg__Gk3Lt","lift":"logo-grid_lift__v_BsX"};